import { isSessionStorageAllowed } from '../web-storage';

export const saveTrafficSource = (
  restaurantId: string,
  channel: string
): void => {
  if (!isSessionStorageAllowed()) {
    return;
  }

  sessionStorage.setItem(`${restaurantId}:cnChannel`, JSON.stringify(channel));
};

/**
 * gets the traffic source from the query params and falls back to session storage
 * this is the primary way to identify the traffic source or (OBN)
 * @param restaurantId
 */
export const getTrafficSource = (restaurantId?: string): string | null => {
  const queryParams = new URLSearchParams(window.location.search);
  const cnChannel = queryParams.get('cn_channel');

  if (typeof cnChannel === 'string') {
    return cnChannel;
  }

  if (!restaurantId) return null;

  return getTrafficSourceFromSessionStorage(restaurantId);
};

/**
 * gets the traffic source from the session storage only and bypasses any query params
 * @param restaurantId
 */
export const getTrafficSourceFromSessionStorage = (
  restaurantId: string
): string | null => {
  if (!isSessionStorageAllowed()) {
    return null;
  }

  const trafficSource = JSON.parse(
    sessionStorage.getItem(`${restaurantId}:cnChannel`) ??
      // legacy, @todo remove
      sessionStorage.getItem(`cnChannel`) ??
      'null'
  );

  return typeof trafficSource === 'string' ? trafficSource : null;
};
